<template>
  <div tabindex="-1" style="outline: none" @keyup.enter="$emit('search')">
    <div class="filter-search-bar">
      <div class="row px-3">
        <v-select
          v-if="$can('filter_consultations')"
          class="col-md-3 my-3"
          name="examinationsFilters"
          :options="searchOptions.examinationsFilters"
          :reduce="(filter) => filter.value"
          :model-value="searchFields.mainFilter"
          label="text"
          :placeholder="trans('evaluation.selectExaminationFilterPlaceholder')"
          @update:model-value="$emit('select-main-filter', $event)"
        >
          <template #option="option">
            <span :data-test="`examinations-filter-option-${option.value}`">{{
              option.text
            }}</span>
          </template>
        </v-select>

        <v-select
          v-if="$can('filter_consultations')"
          class="col-md-3 my-3"
          multiple
          name="extraFilters"
          :options="searchOptions.extraFilters"
          :model-value="selectedExtraCaseFiltersList"
          label="text"
          :placeholder="trans('evaluation.selectCaseFilterPlaceholder')"
          @update:model-value="$emit('select-extra-filters', $event)"
        >
          <template #option="option">
            <span
              :data-test="`examinations-extra-filter-option-${option.value}`"
              >{{ option.text }}</span
            >
          </template>
        </v-select>

        <form class="col my-3 input-group" @submit.prevent="$emit('search')">
          <input
            id="search-field"
            :value="searchFields.query"
            type="text"
            class="form-control"
            :placeholder="trans('general.searchCaseAndPatient')"
            :title="trans('general.search')"
            @input="searchFields.query = $event.target.value"
          />

          <span class="input-group-btn pl-4">
            <button
              v-if="isSearching"
              class="btn btn-danger mr-2"
              type="button"
              @click.stop="$emit('clear-search')"
            >
              <span>{{ trans("general.clearSearch") }}</span>
              <i class="fal fa-times"></i>
            </button>
            <button
              class="btn btn-primary"
              type="button"
              data-test="examinations-search-submit"
              @click.stop="$emit('search')"
            >
              <span>{{ trans("general.search") }}</span>
              <i class="far fa-search"></i>
            </button>
          </span>
        </form>
      </div>
    </div>

    <div
      v-if="isAdvancedSearchOpen"
      class="advanced-search"
      data-test="examinations-advanced-search-panel"
    >
      <div class="row">
        <div v-if="products.length > 1" class="col-md-4">
          <label>{{ trans("evaluation.tableColumnProduct") }}</label>
          <v-select
            name="products"
            :options="products"
            :model-value="searchFields.products"
            label="display_name"
            :reduce="(product) => product.id"
            :placeholder="
              trans('examination.externalResourceSelectPlaceholder')
            "
            @update:model-value="$emit('select-product', $event)"
          ></v-select>
        </div>
      </div>

      <search-option-basic
        :search-fields="searchFields"
        :search-options="searchOptions"
        :options-loading="optionsLoading"
      ></search-option-basic>

      <search-option-mole
        v-if="moleDiagnosisFieldsVisible"
        :search-fields="searchFields"
        :search-options="searchOptions"
      ></search-option-mole>

      <search-option-mole-uk
        v-else-if="isMoleUkProduct"
        :search-fields="searchFields"
        :search-options="searchOptions"
      ></search-option-mole-uk>

      <div class="row">
        <div class="col-md-4">
          <span class="float-left pb-2">
            {{ trans("evaluation.numberOfSearchResult") }}
            <span data-test="examinations-result-total">{{ resultTotal }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="filter-links">
      <span class="float-right pb-2">
        <a
          class="advanced-btn"
          data-test="examinations-advanced-search-toggle"
          @click="$emit('toggle-advanced-search')"
        >
          {{ trans("evaluation.advancedShow") }}
          <i
            class="far fa-angle-down"
            :class="[
              isAdvancedSearchOpen ? 'fa-angle-up' : 'fa-angle-down',
              'far',
            ]"
          ></i>
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import SearchOptionBasic from "./SearchOptionBasic.vue";
import SearchOptionMole from "./SearchOptionMole.vue";
import SearchOptionMoleUk from "./SearchOptionMoleUK.vue";

export default {
  components: {
    SearchOptionBasic,
    SearchOptionMole,
    SearchOptionMoleUk,
  },
  props: {
    searchFields: { type: Object, required: true },
    searchOptions: { type: Object, required: true },
    products: { type: Array, default: () => [] },
    selectedExtraCaseFiltersList: { type: Array, default: () => [] },
    isSearching: { type: Boolean, default: false },
    isAdvancedSearchOpen: { type: Boolean, default: false },
    optionsLoading: { type: Boolean, default: false },
    moleDiagnosisFieldsVisible: { type: Boolean, default: false },
    isMoleUkProduct: { type: Boolean, default: false },
    resultTotal: { type: Number, default: 0 },
  },
  emits: [
    "search",
    "clear-search",
    "select-main-filter",
    "select-extra-filters",
    "select-product",
    "toggle-advanced-search",
  ],
};
</script>
